<template>
  <vs-sidebar
    id="sidebar-question"
    :class="{ 'position-fixed': clickNotClose }"
    class="items-no-padding vs-sidebar-rounded background-absolute w-full"
    parent="#algolia-content-container"
    :click-not-close="clickNotClose"
    :hidden-background="clickNotClose"
    v-model="isFilterSidebarActive"
  >
    <div style="overflow-y: auto; max-height: 70vh">
      <div class="mx-4 mb-4 mt-4">
        <vs-input
          @keyup="change_data_sidebar"
          class="w-full"
          :label="$t('MODULE.nameForm')"
          :placeholder="$t('MODULE.nameForm')"
          v-model.trim="nameForm"
        />
      </div>
      <div class="mx-2 mb-4 mt-4">
        <vs-select
          autocomplete
          :disabled="disabledGroup"
          class="selectExample mt-5 w-full px-2"
          v-model="grupo"
          :label="$t('MODULE.group')"
          @change="getGroupToCreate(grupo)"
        >
          <vs-select-item :key="index" :value="grupo.key" :text="grupo.name" v-for="(grupo, index) in group" />
        </vs-select>
      </div>

      <div class="mx-5 mb-4 mt-4">
        <vs-row vs-type="flex" vs-justify="space-between">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <b>{{ $t("MODULE.version") }}</b>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
            <b>{{ this.dataSidebar.version }}</b>
          </vs-col>
          <vs-col vs-align="center" vs-w="6"> </vs-col>
        </vs-row>
      </div>

      <div class="mx-5 mb-4 mt-4" :key="key">
        <vs-divider />
        <vs-row v-if="CheckPermision('standar_forms')" class="mb-3" vs-type="flex" vs-justify="space-between">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <b>Formulario</b>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
            <vs-radio v-model="isSubForm" vs-value="0"></vs-radio>
          </vs-col>
        </vs-row>
        <vs-row v-if="CheckPermision('sub_forms')" class="mb-3" vs-type="flex" vs-justify="space-between">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <b>Subformulario</b>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
            <!-- <vs-checkbox v-model="isSubForm">1</vs-checkbox> -->
            <vs-radio v-model="isSubForm" vs-value="1" @change="validateForm('SubFormulario')"></vs-radio>
          </vs-col>
        </vs-row>
        <vs-row v-if="CheckPermision('bot_forms')" vs-type="flex" vs-justify="space-between">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
            <b>Bot(VIKI)</b>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
            <vs-radio v-model="isSubForm" vs-value="2" @change="validateForm('BOT')"></vs-radio>
          </vs-col>
        </vs-row>
      </div>

      <div class="mx-4 mb-4">
        <vs-divider />
        <div
          @click="addPage()"
          :class="{
            'bottom-disabled': !buttomAddPage,
            'cursor-pointer': buttomAddPage
          }"
          class="
            item-view-secondary-action-btn
            bg-primary
            mx-4
            my-3
            p-3
            flex flex-grow
            items-center
            justify-center
            text-white
          "
        >
          <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />
          <span class="text-sm font-semibold ml-2">{{ $t("MODULE.addPage") }}</span>
        </div>
        <h5 class="text-center font-bold">{{ $t("MODULE.pagination") }}</h5>
        <h5 class="text-center mt-2">{{ totalPages }} {{ $t("MODULE.totalQuestions") }}</h5>
        <div>
          <div class="flex justify-between mt-3" v-for="(page, index) in ListPages" :key="index">
            <span
              class="font-bold cursor-pointer w-full"
              @click="currentPage === index ? null : change_page(index, page)"
              :class="{ 'text-primary': currentPage === index }"
            >
              {{ $t("MODULE.page") }} {{ index + 1 }}
            </span>
            <div class="flex items-center">
              <span
                @click="currentPage === index ? null : change_page(index, page)"
                class="font-bold pr-2 cursor-pointer"
                :class="{
                  'text-primary': currentPage === index
                }"
                >{{ page.total }}</span
              >

              <feather-icon
                :class="{
                  'bg-disabled': page.total > 0,
                  'cursor-pointer': page.total === 0
                }"
                class="ml-3"
                icon="Trash2Icon"
                svgClasses="h-7 w-7"
                @click="page.total > 0 ? null : deletePage(page)"
              />
            </div>
          </div>
        </div>
      </div>

      <CreateGroupPopup :active="popupActive" @newValue="closeCreateGroup" @groupCreate="newGroup" />
    </div>
  </vs-sidebar>
</template>

<script type="text/javascript">
import { mapState, mapGetters, mapMutations } from "vuex";
import { createJsonForm } from "./helpers/recreateForm";
import { validationViki } from "./validateSchema/vikiSchema";
import { validationSubformulario } from "./validateSchema/subformularioSchema";
import { confirm } from "./helpers/index";
import { _Permissions } from "@/acl/permitions.js";
import CreateGroupPopup from "./components/Sidebar/CreateGroupPopup.vue";
import {
  createPage,
  getAllPages,
  getQuestionsByPage,
  setQuestion,
  deletePage,
  updateFormType
} from "./indexDB/logic.js";
export default {
  mixins: [_Permissions],
  data() {
    return {
      listGroup: [],
      currentPage: 0,
      popupActive: false,
      key: 0
    };
  },
  methods: {
    ...mapMutations("resource", ["UPDATE_STATE", "CHANGE_DATA_SIDEBAR"]),
    async newGroup(newGroup) {
      // const result = await this.$store.dispatch("resource/getApi", "/groups");
      // this.listGroup = result;
      const { key } = newGroup;
      this.grupo = key;
    },
    async closeCreateGroup(event) {
      this.popupActive = event;
      // this.grupo = "";
      const result = await this.$store.dispatch("resource/getApi", "/groups");
      this.listGroup = result;
    },
    async getGroupToCreate(group) {
      if (group === -1) {
        this.grupo = "";
        this.popupActive = true;
        return;
      }
      this.change_data_sidebar();
    },
    async addPage() {
      setQuestion();
      const ultimaPage = this.ListPages[this.ListPages.length - 1];
      if (ultimaPage.total > 0) {
        const page = {
          id_form: this.idForm,
          questions: []
        };
        const id_page = await createPage(page);
        this.UPDATE_STATE({ key: "idPage", value: id_page });
        this.UPDATE_STATE({ key: "questionsByPage", value: [] });
        const allPages = await getAllPages();
        this.UPDATE_STATE({ key: "allPages", value: allPages });
        this.currentPage = this.ListPages.length - 1;
      }
    },
    async change_page(index, page) {
      await setQuestion();
      this.currentPage = index;
      this.UPDATE_STATE({ key: "idPage", value: page.key });
      const questions = await getQuestionsByPage();
      this.UPDATE_STATE({ key: "questionsByPage", value: questions });
    },
    change_data_sidebar() {
      const data = {
        nameForm: this.nameForm,
        grupo: this.grupo,
        isSubForm: this.isSubForm,
        version: this.dataSidebar.version,
        formID: this.dataSidebar.formID,
        companyID: this.dataSidebar.companyID,
      };
      this.CHANGE_DATA_SIDEBAR(data);
    },
    async deletePage(page) {
      await deletePage(page.key);
      const allPages = await getAllPages();
      this.UPDATE_STATE({ key: "allPages", value: allPages });
      const firstPage = this.ListPages[0];
      this.change_page(0, firstPage);
    },
    async validateForm(type) {
      try {
        const json = await createJsonForm();
        let result = null;
        if(json.length === 0) return
        if (type === "BOT") result = validationViki(json);
        else result = validationSubformulario(json);
        console.log(result)

        if (!result.valid) {
          this.isSubForm = "0";
          this.key++;

          const keywordEnum = result.error.filter(enumK => enumK.keyword === "enum");

          if (keywordEnum.length > 0) {
            const isType = keywordEnum.some(item => item.instancePath.split("/")[2] === "type");

            if (isType) {
              const types = keywordEnum
                .filter(item => item.instancePath.split("/")[2] === "type")
                .map(item => this.$t(`${item.parentSchema.pathI18n}.${item.data}`));

              const text =
                `Los siguientes tipos de preguntas no son permitidas para un <b>${type}:</b> <br><br>` +
                types.join(", ");
              confirm({ title: "Validación", text, type: null, templete: true });
              return;
            }

            const isInputType = keywordEnum.some(item => item.instancePath.split("/")[2] === "inputType");

            if (isInputType) {
              const inputType = keywordEnum
                .filter(item => item.instancePath.split("/")[2] === "inputType")
                .map(item => item.data);

              const text =
                `Los siguientes clases de preguntas no son permitidas para un <b>${type}:</b> <br><br>` +
                inputType.join(", ");
              confirm({ title: "Validación", text, type: null, templete: true });
              return;
            }
          }

          const text = `No se puede realizar el cambio, algunas de las razones:<br><br>
             <b>1.</b> Puede haber preguntas que no sean validas para un subformualrio. <br><br>
             <b>2.</b> La estructura del formulario puede contener propiedades adicionales no permititdas.<br><br>
             <b>3.</b> Algunas de sus propiedades estan en vacio o faltan por completar.`;
          confirm({ title: "Validación", text, type: null, templete: true });
        }

        // if (!result.valid) {
        //   const getInputType = result.error[0].dataPath.split(".")[1];

        //   if (getInputType === "inputType" || getInputType === "type") {
        //     this.isSubForm = "0";
        //     this.key++;
        //     const params = result.error[0].params;

        //     if (params.hasOwnProperty("allowedValues")) {
        //       const getValues = params.allowedValues;
        //       const getInputypeJson = json.map(item => item[getInputType]);
        //       const getErrors = getInputypeJson.filter(item => !getValues.includes(item));
        //       const deleteDuplicated = [...new Set(getErrors)];

        //       const text =
        //         `Los siguientes tipos de preguntas no son permitidas para un <b>${type}:</b> ` +
        //         deleteDuplicated.toString();

        //       confirm({ title: "Validación", text, type: null, templete: true });
        //     }
        //   }
        // }
      } catch (error) {
        console.log("Error ", error);
      }
    }
  },
  computed: {
    ...mapState("resource", ["clickNotClose", "isFilterSidebarActive", "idForm", "dataSidebar", "disabledGroup"]),
    ...mapGetters("resource", ["totalPages", "ListPages"]),
    group() {
      const html = `
        <div class="text-center">
          <button class="addGroup w-full rounded bg-white text-primary h-8 py-2 cursor-pointer">CREAR GRUPO</button>
        </div>`;

      if (this.listGroup === undefined || this.listGroup.length === 0) return [{ name: html, key: -1 }];

      let list = this.listGroup.map(group => {
        return {
          name: group.name,
          key: group.key
        };
      });

      list.unshift({ name: html, key: -1 });
      return list;
    },
    nameForm: {
      get() {
        return this.dataSidebar.nameForm;
      },
      set(value) {
        const data = {
          nameForm: value,
          grupo: this.grupo,
          isSubForm: this.isSubForm,
          version: this.dataSidebar.version,
          formID: this.dataSidebar.formID,
          companyID: this.dataSidebar.companyID,
        };
        this.CHANGE_DATA_SIDEBAR(data);
      }
    },
    grupo: {
      get() {
        return this.dataSidebar.grupo;
      },
      set(value) {
        const data = {
          nameForm: this.nameForm,
          grupo: value,
          isSubForm: this.isSubForm,
          version: this.dataSidebar.version,
          formID: this.dataSidebar.formID,
          companyID: this.dataSidebar.companyID,
        };
        this.CHANGE_DATA_SIDEBAR(data);
      }
    },
    // version() {
    //     return this.dataSidebar.version;
    // },

    isSubForm: {
      get() {
        return this.dataSidebar.isSubForm;
      },
      set(value) {
        const data = {
          nameForm: this.nameForm,
          grupo: this.grupo,
          isSubForm: value,
          version: this.dataSidebar.version,
          formID: this.dataSidebar.formID,
          companyID: this.dataSidebar.companyID,
        };
        updateFormType(value);
        this.CHANGE_DATA_SIDEBAR(data);
      }
    },
    buttomAddPage() {
      const ultimaPage = this.ListPages[this.ListPages.length - 1];
      if (ultimaPage) return ultimaPage.total > 0;
      return false;
    }
  },
  async created() {
    const result = await this.$store.dispatch("resource/getApi", "/groups");
    this.listGroup = result;
  },
  components: { CreateGroupPopup }
};
</script>

<style type="text/css">
.bg-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.bottom-disabled {
  cursor: not-allowed !important;
  opacity: 0.5;
}

.addGroup {
  border: 1px solid rgb(56, 189, 170);
}
</style>
